<header
  fxLayout="row wrap"
  fxLayoutAlign="center center"
  class="default-header"
  [ngClass]="
    {
      '/': 'home-page',
      '/product': 'product-page',
      '/product/healthcare-provider': 'product-healthcare-provider-page',
      '/product/pharma-company': 'product-pharma-company-page'
    }[activeRoute]
  "
>
  <div fxFlex="30" fxFlex.sm="10" fxFlex.xs="40">
    <a fxFlex="90" fxFlex.xs="10" fxFlex.sm="10" routerLink="./" fxFlexFill>
      <!-- <img src="assets/img/home/docformative-logo.svg" style="margin-top: 33px" /> -->
      <div class="logo" fxShow="true" fxShow.sm="false" fxShow.xs="false">
        <img src="assets/img/home/common/logo-img1.svg" alt="logo" />
        <img src="assets/img/home/common/logo-img2.svg" alt="logo" class="white-filter" />
      </div>
      <img
        src="assets/img/home/docformative-small-logo.svg"
        fxShow="false"
        fxShow.sm="true"
        fxShow.xs="true"
        (click)="showMenu = false"
        style="margin: 15px 0 15px 0"
        class="white-filter"
      />
    </a>
  </div>
  <div fxFlex="50%" fxLayoutAlign="end" fxHide fxShow.xs>
    <div class="menu-icon" [ngClass]="{ close: showMenu === true }" (click)="showMenu = !showMenu">
      <span class="line-1"></span>
      <span class="line-2"></span>
      <span class="line-3"></span>
    </div>
  </div>
  <nav
    fxFlex="63"
    fxFlex.sm="78"
    fxFlex.xs="100"
    fxFlexOffset.sm="5"
    fxLayout="row"
    fxShow.xs="{{ showMenu }}"
    ngClass.xs="small-nav-screen"
    fxLayoutAlign="start stretch"
    fxLayoutAlign.xs="center start"
  >
    <div fxFlex fxFlex.xs="90" fxLayout="row wrap" fxLayoutAlign="space-between center">
      <div
        fxFlexFill
        fxLayout="row"
        fxLayout.xs="column"
        fxFlex="63"
        fxLayoutGap="5%"
        fxLayoutGap.sm="2.5%"
        fxLayoutGap.xs="0"
        fxLayoutAlign.xs="start start"
        fxLayoutAlign="center center"
      >
        <a class="default-paragraph" routerLinkActive="router-link-active" routerLink="./product" (click)="showMenu = false">Product</a>
        <a class="default-paragraph" routerLinkActive="router-link-active" routerLink="./about" (click)="showMenu = false"> About </a>
        <a class="default-paragraph" routerLinkActive="router-link-active" routerLink="./news" (click)="showMenu = false">News</a>
        <a class="default-paragraph" routerLinkActive="router-link-active" routerLink="./contact" (click)="showMenu = false">Contact</a>
        <a class="default-paragraph" routerLinkActive="router-link-active" routerLink="./faq" (click)="showMenu = false"> FAQ </a>
        <div fxShow.xs fxHide>&nbsp;</div>
        <div fxShow.xs fxHide>&nbsp;</div>
      </div>
      <div fxLayout="row" fxFlex="155px" fxFlex.xs="100">
        <a fxFlex="100" mat-flat-button class="default-paragraph login-button" routerLink="./login" (click)="showMenu = false"> Login </a>
      </div>
    </div>
  </nav>
</header>
